<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import ListingTable from "@/components/listings/listing-table";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
        InputGroup,
        SelectGroup
    },
    data() {
        return {
            title: "Treatments",
            items: [
                {
                    text: "Treatments"
                },
            ],
            filter: {
                display_name: '',
                branch_id: null,
                product_id: null,
                category: null,
                status: 1,
            },
            statusOptions: [
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
            ],
            fields: [
                { key: "action" },
                { key: "id", sortable: true, label: "ID" },
                { key: "sku", sortable: true, label: "SKU" },
                // { key: "display_image", sortable: false, label: "Image" },
                { key: "display_name", sortable: true, label: "Name" },
                { key: "display_category", sortable: true, label: "Category" },
                { key: "price", sortable: false, label: "Price" },
                { key: "commission_type", sortable: false, label: "Commission Type" },
                { key: "commission", sortable: false, label: "Commission" },
                { key: "duration", sortable: true, label: "Duration" },
                { key: "branch_id", sortable: true, label: "Branch" },
                { key: "status", sortable: true, label: "Status" },
            ],
            selectedCategory: null,
            categoryOptions: [],
            branchOptions: [],
            productOptions: [],
        };
    },
    computed: {

    },
    watch: {

    },
    async mounted() {
        this.retrieveBranches().then((branches) => {
            this.branchOptions = branches.map((branch) => ({
                name: branch.name,
                value: branch.id,
            }));
        });

        this.retrieveProducts().then((products) => {
            const productArray = Object.values(products);
            this.productOptions = productArray.map((product) => ({
                name: product.description.name,
                value: product.id,
            }));
        });

        this.retrieveCategories().then((categories) => {
            this.categoryOptions = categories.map((category) => ({
                name: category.display_name,
                value: category.id,
            }));
        });
    },
    methods: {
        async retrieveBranches() {
            this.loading = true;
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    branches = result['data'].branches;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return branches;
        },

        async retrieveProducts() {
            this.loading = true;
            let products = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/all-product`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    products = result['data']['products'];
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return products;
        },

        async retrieveCategories() {
            this.loading = true;
            let categories = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/category`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    categories = result['data'].categories;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return categories;
        },

        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/product/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable();
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete treatment (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        },

        resetFilter() {
            this.filter = {
                display_name: '',
                branch_id: null,
                product_id: null,
                category: null,
                status: 1
            };

            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <div class="row mt-2 ml-0">
                            <router-link class="btn btn-success mb-2" :to="{name: 'Treatment Form', params: {id: 'add'}}"><i class="mdi mdi-plus mr-2"></i> Add Treatment</router-link>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-4 mt-2">
                                <InputGroup id="search" type="text" displayName="Search" v-model="filter.display_name" :onEnter="filterTable" :placeholder="'Search by SKU or name'" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <SelectGroup id="branch_id" v-model="filter.branch_id" displayName="Branch" :options="branchOptions" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <SelectGroup id="treatment" v-model="filter.product_id" displayName="Treatment" :options="productOptions" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-4 mt-2">
                                <SelectGroup id="category" displayName="Category" v-model="filter.category" :options="categoryOptions" track-by="value" :searchable="true" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <SelectGroup id="status" displayName="Status" v-model="filter.status" :options="statusOptions" />
                            </div>
                            <div class="col-12">
                                <a href="javascript:void(0);" class="btn btn-success mt-2" @click="filterTable">
                                    Filter
                                </a>
                                <a href="javascript:void(0);" class="btn btn-danger ml-3 mt-2" @click="resetFilter">
                                    Reset
                                </a>
                            </div>
                        </div>
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="product" listName="products">
                            <template v-slot:cell(status)="{ item }">
                                <div class="badge font-size-12" :class="{
                                    'badge-soft-danger': `${item.display_status}` === '0',
                                    'badge-soft-success': `${item.display_status}` === '1',
                                }">{{ item.display_status === 1 ? 'Active' : 'Inactive' }}</div>
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" v-b-tooltip.hover title="Edit" :to="{name: 'Treatment Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                            <template v-slot:cell(display_name)="{ item }">
                                <b>{{ item.display_name }}</b>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>